var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flex-horizontal',{attrs:{"inline":""}},[_c('license-type-icon',{attrs:{"icon-name":_vm.iconName,"force-gray":""}}),_vm._v(" "),_c('body-regular',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }